import crypto from "crypto";

import { EcwSessionCryptoError } from "@/src/lib/ehr/ecw/webecw/errors";

export function computePdChecksum(urlQuery: string, body: string): string {
  const decode = (s: string) => decodeURIComponent(s).replace(/\+/g, " ");
  const q = urlQuery ? decode(urlQuery) : "";
  const b = decode(body);
  const digest = crypto
    .createHash("sha256")
    .update(q + b, "utf8")
    .digest("hex");

  return encodeURIComponent(digest);
}

export function encryptDataWithAES(plaintext: string, aesKey: string, aesIv: string): string {
  const keyBuf = Buffer.from(aesKey, "latin1");
  const ivBuf = Buffer.from(aesIv, "latin1");
  const bits = keyBuf.length * 8;

  if (![128, 192, 256].includes(bits)) {
    throw new EcwSessionCryptoError("aesKey", `unsupported length ${keyBuf.length} bytes (need 16/24/32)`);
  }

  if (ivBuf.length !== 16) {
    throw new EcwSessionCryptoError("aesIv", `length ${ivBuf.length} bytes (need 16)`);
  }

  const plaintextBuf = Buffer.from(plaintext, "utf8");
  const rem = plaintextBuf.length % 16;
  const paddedBuf = rem === 0 ? plaintextBuf : Buffer.concat([plaintextBuf, Buffer.alloc(16 - rem, 0x20)]);

  const cipher = crypto.createCipheriv(`aes-${bits}-cbc`, keyBuf, ivBuf);

  cipher.setAutoPadding(false);

  return Buffer.concat([cipher.update(paddedBuf), cipher.final()]).toString("base64");
}
